import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import dayjs from 'dayjs'
import { nextTick, ref, watch } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    width: {
        // 宽度
        type: String,
        default: '140px',
    },
    isDisabled: {
        // 是否禁用
        type: Boolean,
        default: false,
    },
    modelValue: {
        // 绑定的开始结束日期值
        type: Array,
        default: () => ['', ''],
    },
    inputSize: {
        // size 大小
        type: String,
        default: '',
    },
    dateType: {
        // 组件类型
        type: String,
        default: 'date',
    },
    valueFormat: {
        // 格式
        type: String,
        default: 'YYYY-MM-DD',
    },
    format: {
        // 格式
        type: String,
        default: 'YYYY-MM-DD',
    },
    clearable: {
        type: Boolean,
        default: false,
    },
    msg: {
        // 格式
        type: String,
        default: '',
    },
    placeholder: {
        type: Array,
        default: () => ['开始日期', '结束日期'],
    },
    disableDay: {
        type: Number,
        default: 30,
    },
    size: {
        type: String,
        default: '',
    },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit }) {

const props = __props;




let startEnd = ref<any[]>(['', ''])
watch(
    () => props.modelValue,
    newValue => {
        startEnd.value = newValue
    },
    { immediate: true }
)

watch(
    () => props.size,
    () => {
        nextTick(() => {
            const keyNode = document.querySelector('.el-range__icon')
            let iNode = document.createElement('i')
            if (props.size === 'small') iNode.setAttribute('class', 'iconfont icon-Calendar font-11')
            else iNode.setAttribute('class', 'iconfont icon-Calendar')
            if (keyNode) keyNode.appendChild(iNode)
        })
    },
    { immediate: true }
)

function dateChange() {
    const value = [startEnd.value[0] || '', startEnd.value[1] || '']
    emit('update:modelValue', value)
    emit('change', value)
}
const startVal = ref(null)
const calendarChange = (e: any) => {
    if (e[0] && !e[1]) {
        startVal.value = e[0]
    }
}

const visibleChange = (e: any) => {
    if (e) {
        startVal.value = null
    }
}

const disabledFn = (current: any) => {
    if (!startVal.value) return false
    let range = [dayjs(startVal.value).subtract(0, 'day'), dayjs(startVal.value).add(props.disableDay, 'day')]
    let cur = dayjs(current)
    return cur < range[0] || cur > range[1]
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createBlock(_component_el_date_picker, {
    modelValue: _unref(startEnd),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(startEnd) ? (startEnd).value = $event : startEnd = $event)),
    type: "daterange",
    "range-separator": "～",
    "start-placeholder": props.placeholder[0],
    "end-placeholder": props.placeholder[1],
    format: props.format,
    "value-format": props.valueFormat,
    clearable: props.clearable,
    onChange: dateChange,
    "prefix-icon": "prefix-icon-class",
    onCalendarChange: calendarChange,
    onVisibleChange: visibleChange,
    "disabled-date": disabledFn
  }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "format", "value-format", "clearable"]))
}
}

})